import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { withTranslation, Trans } from "react-i18next";
import InsButton from "../../../../components/InsButton/InsButton";
import InsInput from "../../../../components/InsInput/InsInput";
import Validate from "../../../../ressources/validation";
import ValidatePassword from "../../../../components/ValidatePassword/ValidatePassword";
import StepCount from "../../../../components/StepCount/StepCount";
import "./Step3.scss";
import { connect } from "react-redux";
import ConnectOptin from "components/ConnectOptin/ConnectOptin";
import PhoneInput from "components/PhoneNumerInput/PhoneInput";

class Step3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordConfirm: "",
      passwordConfirmError: "",
      captcha: "bypassed",
      optins: [],
      fields: [],
      newsletter: false,
      validConsent: false,
      profileConsent: false,
    };
    this.phoneRef = createRef();
  }
  static propTypes = {
    onValidate: PropTypes.func,
  };

  componentDidMount() {
    const { config } = this.props;
    const { connect } = config.register;

    this.getCodeSponsorship();
    this.setState({
      fields: connect.filter((field) => field.name !== "profile_consent").map((field) => ({
        ...field,
        value: this.props.userInfo[field.name] || "",
        error: "",
      }))
    });
  }

  _handleProfileConsentChange = (event) => {
    const checked = event?.target
      ? event.target.checked
      : Boolean(event);

    this.setState({ profileConsent: checked });
  };

  getCodeSponsorship = () => {
    const { userInfo } = this.props;
    const { code_parrainage } = userInfo;

    if (code_parrainage) {
      this.setState({ sponsorship: code_parrainage });
    }
  };

  _handlePhoneNumberChange = (number) => {
    const { fields } = this.state;
    const index = fields.findIndex((el) => el.name === "phone");
    if (index === -1) return;
    let newFields = [...fields];
    newFields[index].value = number;
    if (!newFields[index].required && !number?.trim()) {
      newFields[index].error = null;
    }
    this.setState({ fields: newFields });
  }

  _handleChange = (input) => (e) => {
    const value = e.target.value;
    const { fields } = this.state;
    if (input === "emailConfirm"){
      this.setState({ emailConfirm: value });
    } 
    else if (input !== "passwordConfirm") {
      const index = fields.findIndex((el) => el.name === input);
      let newFields = [...fields];
      newFields[index].value = value;
      this.setState({ fields: newFields });
    } else {
      this.setState({ passwordConfirm: value });
    }
  };

  _isEmailValid = () => {
    const { fields, emailConfirm } = this.state;
    const index = fields.findIndex((el) => el.name === "email");
    if (index === -1) return true;

    return (
      !Validate("email", fields[index].value) &&
      fields[index].value?.toLowerCase() === emailConfirm?.toLowerCase()
    );
  };

  _validateEmailConfirm = (isFromEmailField = false) => {
    const { fields, emailConfirm, emailConfirmError } = this.state;
    const { t } = this.props;
    const index = fields.findIndex((el) => el.name === "email");
    if (index === -1) return true;
    if (isFromEmailField && !emailConfirm && !emailConfirmError) {
      this.setState({
        emailConfirmError: "",
      });
    } else if (!this._isEmailValid()) {
      this.setState({
        emailConfirmError: t("error_email_not_same"),
      });
    } else {
      this.setState({
        emailConfirmError: "",
      });
    }
    return fields[index].value?.toLowerCase() === emailConfirm?.toLowerCase();
  };

  /**
   * Valide le champ parrainage
   */
  // _validateSponsorship = () => {
  //   const error = Validate("sponsorship", this.state.sponsorship);
  //   this.setState({
  //     sponsorshipError: error
  //   });
  //   return !error;
  // };

  /**
   * Valide la confirmation du champ password
   */
  _isPasswordValid = () => {
    const { fields, passwordConfirm } = this.state;
    const index = fields.findIndex((el) => el.name === "password");
    if (index === -1) return true;

    return fields[index].value === passwordConfirm;
  };

  _validatePasswordConfirm = () => {
    const { fields, passwordConfirm } = this.state;
    const { t } = this.props;
    const index = fields.findIndex((el) => el.name === "password");
    if (index === -1) return true;

    if (!passwordConfirm) {
      this.setState({
        passwordConfirmError: "",
      });
    } else if (!this._isPasswordValid()) {
      this.setState({
        passwordConfirmError: t("error_password_not_same"),
      });
    } else {
      this.setState({
        passwordConfirmError: "",
      });
    }
    return fields[index].value === passwordConfirm;
  };

  _validateField =
    (input) =>
    (displayError = true) => {
      const { fields } = this.state;
      const index = fields.findIndex((el) => el.name === input);
      if (!fields[index].required && fields[index].name !== "phone" && !fields[index].value) {
        return true;
      }
      let error;
      if (fields[index].name === "phone") {
        if (fields[index].required || fields[index].value) {
          error = !this.phoneRef?.current?.getInstance()?.isValidNumber(fields[index].value);
        } else {
          error = false;
        }
      } else {
        error =
          Validate("required", fields[index].value) ||
          Validate(fields[index].name, fields[index].value);
      }
      if (displayError) {
        let newFields = [...fields];
        newFields[index].error = error;
        this.setState({
          fields: newFields,
        });
      }
      return !error;
    };

  /**
   * Vailde le formulaire de l'étape
   */
  _validateFormStep = () => {
    const { fields, validConsent, profileConsent } = this.state;
    const { config } = this.props;

    let validation = fields.every((el) => this._validateField(el.name)(false)) && validConsent;

    // Don't want to spend one more minute on this project so I'm going to do it like this
    const profileConsentField = config?.register?.connect.find(field => field.name === "profile_consent");
    if (profileConsentField && profileConsentField.required && !profileConsent) {
        validation = false;
    }

    if (fields.length > 0) {
      validation = validation  && this._isEmailValid() && this._isPasswordValid();
    }

    return validation;
  };

  _onValidate = () => {
    const { onValidate } = this.props;
    const { fields, optins, profileConsent } = this.state;
    let store = {
      opt_ins: {
        custom: {},
      },
      newsletter: this.state.newsletter,
    };
    fields.forEach((el) => {
      if(el.name !== "profile_consent") {
        store[el.name] = el.value;
      }
    });
    optins.forEach((el) => {
      if (el.id !== "gdpr") {
        if (el.id !== "newsletter") {
          store.opt_ins["custom"][el.id] = el.value;
        } else {
          store.opt_ins[el.id] = el.value;
        }
      }
    });
    store.profile_consent = profileConsent;
    const userInfo = store;
    onValidate(userInfo);
  };

  /**
   * CAPTCHA
   */
  verifyCallback = (recaptchaToken) => {
    // Bypass reCAPTCHA for now
    this.setState({ captcha: "bypassed" });
  };

  // RENDER INPUT TEXT FIELDS
  _renderFields = (field) => {
    const { t } = this.props;
    return (
      <div>
        <InsInput
          name={field.name}
          onChange={this._handleChange(field.name)}
          onBlur={() => {
            this._validateField(field.name)();
          }}
          placeholder={field.required ? t(field.name) + " *" : t(field.name)}
          value={field.value}
          error={field.error}
          autoComplete="new-password"
        />
      </div>
    );
  };

  _renderEmail= (field) => {
    const { t } = this.props;
    return (
      <>
      <div>
        <InsInput
          name={field.name}
          onChange={this._handleChange(field.name)}
          onBlur={() => {
            this._validateField(field.name)();
            this._validateEmailConfirm(true);
          }}
          placeholder={field.required ? t(field.name) + " *" : t(field.name)}
          value={field.value}
          error={field.error}
          autoComplete="new-password"
        />
      </div>
      <div>
          <InsInput
            name="emailConfirm"
            type={field.name}
            placeholder={t("email_confirm")}
            onChange={this._handleChange("emailConfirm")}
            onBlur={() => {
              this._validateEmailConfirm();
            }}
            error={this.state.emailConfirmError}
          />
        </div>
      </>
    );
  };

  // RENDER PASSWORD FIELDS
  _renderPassword = (field) => {
    const { t } = this.props;
    return (
      <>
        <div>
          <InsInput
            name={field.name}
            type={field.name}
            placeholder={field.required ? t(field.name) + " *" : t(field.name)}
            onChange={this._handleChange(field.name)}
            onBlur={() => {
              this._validateField(field.name)();
              this._validatePasswordConfirm();
            }}
            error={field.error}
          />
        </div>
        <div>
          <InsInput
            name="passwordConfirm"
            type={field.name}
            placeholder={t("password_confirm")}
            onChange={this._handleChange("passwordConfirm")}
            onBlur={() => {
              this._validatePasswordConfirm();
            }}
            error={this.state.passwordConfirmError}
          />
        </div>
        <div className="step3-validate-password">
          <ValidatePassword value={field.value}>
            {t("help_password")}
          </ValidatePassword>
        </div>
      </>
    );
  };

  _renderPhone = (field) => {
    const { t } = this.props;
    return (
      <div>
        <PhoneInput
          initialValue={field.value || ""}
          onChangeNumber={this._handlePhoneNumberChange}
          isRequired={field.required}
          darkMode={true}
          ref={this.phoneRef}
        />
      </div>
    );
  };

  render() {
    const { t, config, currentStep, maxSteps } = this.props;
    const { fields, optins } = this.state;
    const grprLink = config.register?.opt_ins?.ppFilePath || "/";
    // const {
    //   sponsorship,
    //   sponsorshipError
    // } = this.state;
    return (
      <>
        <form
          className="default-container col-flex"
          onSubmit={(e) => e.preventDefault()}
        >
          <StepCount step={currentStep} maxStepCount={maxSteps} />
          <p className="bold-label centered mb50">{t("step3")}</p>
          {/* <div className="step3-sponsorship">
            <div className="mb20">
              {t("help_sponsorship")}
              <InsInput
                name="sponsorship"
                type="number"
                onInput={e => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 6);
                }}
                placeholder={t("placeholder")}
                value={sponsorship}
                onChange={this._handleChange("sponsorship")}
                onBlur={this._validateSponsorship}
                error={sponsorshipError}
              />
              <div className="help">{t("not_required")}</div>
            </div>
          </div> */}

          {fields.map((field, index) => {
            switch (field.name) {
              case "password":
                return (
                  <div key={field.name + index}>
                    {this._renderPassword(field)}
                  </div>
                );

              case "birthdate":
                return (
                  <div key={field.name + index}>
                    {this._renderBirthdate(field)}
                  </div>
                );
              
              case "email":
                return (
                  <div key={field.name + index}>
                    {this._renderEmail(field)}
                  </div>
                );
              
              case "phone":
                return (
                  <div key={field.name + index}>
                    {this._renderPhone(field)}
                  </div>
                );

              default:
                {
                  if (field.name === "profile_consent") {
                    return null;
                  } else {
                    return (
                      <div key={field.name + index}>
                        {this._renderFields(field)}
                      </div>
                    );
                  }
                }
            }
          })}

          <div className="legal-age-mentions mb20 mt20">
            <Trans
              i18nKey="legal_age_mentions"
              defaults="You need to be at least 16 to sign up.<br/><br/>One Retail will use your personal data to manage your account and to give you access to the features available on the platform, for analytics, and where you have opted in, to send you communications.<br/><br/>For more information on how we use your personal data, please see our <link1>Privacy Policy</link1>."
              components={{
                br: <br />,
                link1: <a href={grprLink} target="_blank" rel="noreferrer" />
              }}
              />
          </div>

          <ConnectOptin
              optins={optins}
              updateOptins={(data) => this.setState({optins: data})}
              updateNewsletter={(bool) => this.setState({newsletter: bool})}
              updateValidConsent={(bool) => this.setState({validConsent: bool})}
              required={false}
              updateProfileConsent={this._handleProfileConsentChange}
          />

          <div className="bottom-container">
            {!this._validateFormStep() && (
              <div className="alert_msg mb10">{t("required_only")}</div>
            )}
            
            <InsButton
              text={t("create_account")}
              onClick={this._onValidate}
              disabled={!this._validateFormStep()}
            />
          </div>
        </form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  config: state.config,
});

export default connect(mapStateToProps)(withTranslation()(Step3));
